export default {"src":"/_next/static/media/ourmission.eddbcac7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};